export default "__VITE_ASSET__Ds7OOiYD__"